{
    "NAME": "Langue de la liste des périphériques",
    "DeviceList_Column_DeviceNumber": "Appareil",
    "DeviceList_Column_DeviceNumberInternal": "Extension",
    "DeviceList_Column_Description": "Description",
    "DeviceList_Column_Partition": "Partition",
    "DeviceList_Column_DeviceType": "Type d'appareil",
    "DeviceList_Column_IDOnTelSys": "Compte de ressources",
    "DeviceList_Column_QueueStatus": "État de la file d'attente",
    "DeviceList_Column_Users": "Utilisateurs",
    "DeviceList_Filter_DeviceType": "Type d'appareil",
    "DeviceList_Filter_Partition": "Partition",
    "DeviceList_Add_Disabled_SelectTelephonyServer": "Sélectionnez un serveur de téléphonie pour ajouter un appareil",
    "DeviceList_Users_MoreUsers": "[{} plus d'utilisateurs]",
    "DeviceList_Value_None": "Aucun",
    "DeviceList_Value_All": "Tous"
}